























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { hls, Load } from '@/units'
import { lowerCase } from '@/utils'

@Component
export default class Accounts extends Vue {
  // __DATA
  private search: string = ''
  private permission: number = 0
  private active: any = null

  // __CREATED
  public async created () {
    Load(this, true)

    await this.$store.dispatch('APP.USERS/callAcc')
    this.$store.dispatch('APP.USERS/callPer')

    Load(this, false)
  }

  // __METHODS
  private modify (data: any): void {
    if (data.id > 1) {
      this.$emit('events', { type: 'edit', data })
    }
  }

  private p (val: number): string {
    const p: any = this.db.permissions.find((x: any) => x.id === val)
    return p ? p.name : 'undefined'
  }

  private h (val: string): string {
    return hls(val, this.search)
  }
  
  // __COMPUTED
  private get store (): any {
    const search: string = lowerCase(this.search)
    let accounts: any = this.$store.getters['APP.USERS/accounts']

    if (this.search) {
      accounts = accounts.filter((x: any) => lowerCase(x.name).includes(search))
    }

    if (this.permission) {
      accounts = accounts.keep('permission_id', this.permission)
    }

    if (this.active !== null) {
      accounts = accounts.keep('isActive', this.active)
    }

    return accounts
  }

  private get db (): any {
    const permissions: any = this.$store.getters['APP.USERS/permissions']
    return {
      permissions,
      active: [
        { id: 1, name: this.$t('enabled') },
        { id: 0, name: this.$t('disabled') }
      ]
    }
  }
}
